// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"115":"7f8335ee","423":"7f8335ee"}[chunkId] + ".chunk.css";
};